import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import CacheKeys from '../../../cache/CacheKeys';
import CacheManager from '../../../cache/CacheManager';
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils';
import SalesChartPageUI from './SalesChartPageUI';
class SalesChartPageSF extends Component {
  constructor(props) {
    super(props);
    this.state = {
        dataKeys: {
            channel: 'channel',
            month: 'month',
            originator: 'originator',
        },
      errorList: null,
      salesTargetList: [],
      filteredSalesTargetList: [],
      userIdSList: [],
      monthList:[],
      yearList:[],
      salesChannelList: [],
      filteredList:[],
      monthWiseData:[],
      channelWiseData:[],
      originatorWiseData:[],
      month:null,
      channel:null,
      originator:null,
      filter:null,
      filterList:[]
    };
  }

  render() {
    const { dataKeys } = this.state
    return (
      <SalesChartPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        salesTargetList={this.state.salesTargetList}
        filteredSalesTargetList={this.state.filteredSalesTargetList}
        yearList={this.state.yearList}
        
        onRefreshClick={this.onRefreshClick}
        //
        month={this.state.month}
        monthList={this.state.monthList}
        //
        channel={this.state.channel}
        onChannelChange={this.onFilterChange}
        salesChannelList={this.state.salesChannelList}
        //
        originator={this.state.originator}
        onOriginatorChange={this.onFilterChange}
        userIdSList={this.state.userIdSList}
        //
        selectLine={this.handleMouseEnter}
        dataKeys={dataKeys}

        monthWiseData={this.state.monthWiseData}
        channelWiseData={this.state.channelWiseData}    
        originatorWiseData={this.state.originatorWiseData}
        filter = {this.state.filter}
        filterList = {this.state.filterList}
        onFilterChange={this.onFilterChange}
      />
    );
  }

  componentDidMount() {
    const { context } = this.props;
    this.getUsersS(context);
    this.getFilterList();
    this.getFilteredMonthList();
    this.getSalesChannels(context);
    this.getSalesTargetList(context);
  }

  handleMouseEnter = (o) => {
    const { dataKey } = o
    const { dataKeys } = this.state
    if (dataKeys[dataKey] === dataKey) {
      this.setState({
        dataKeys: { ...dataKeys, [dataKey]: dataKeys[dataKey] + ' ' }
      })
    }
    else {
      this.setState({
        dataKeys: { ...dataKeys, [dataKey.trim()]: dataKeys[dataKey.trim()].trim() }
      })
    }
  }

  getSalesTargetList(context) {
    const cacheManager = new CacheManager({
      resource: '/api/su/sales/targets',
      cacheKey: CacheKeys.SalesTargetList(),
      callback: this.getSalesTargetListCallback,
      ttlInSecs: 600,
    });
    cacheManager.getObject2(context);
  }

  getSalesTargetListCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      salesTargetList: response.salesTargetList,
      filteredSalesTargetList: response.salesTargetList,
      monthWiseData: response.monthWiseData,
      channelWiseData: response.channelWiseData,
      originatorWiseData: response.originatorWiseData,
    });
  };

  onFilterChange = (option) => {
     console.log('Filter Type:', option.value);
      this.setState({ filter: option.value })
  };

  applyFilters = () => {
    let filtered = [...this.state.salesTargetList];
  
    if (this.state.channel && this.state.channel) {
      filtered = filtered.filter(item => item.channel.toString() === this.state.channel.toString());
    }
    if (this.state.month &&this.state.month) {
      filtered = filtered.filter(item => item.month.toString().substring(0, 3).toLowerCase() === this.state.month.toString().substring(0, 3).toLowerCase());
    }
    if (this.state.originator && this.state.originator) {
      console.log('Originator:', this.state.originator);
      filtered = filtered.filter(item =>  item.userId.toString() === this.state.originator.toString());
    }
  
    this.setState({ filteredSalesTargetList: filtered });
  };

  getFilteredMonthList() {
    let months = [
      { value: '01', label: 'Jan' },
      { value: '02', label: 'Feb' },
      { value: '03', label: 'Mar' },
      { value: '04', label: 'Apr' },
      { value: '05', label: 'May' },
      { value: '06', label: 'Jun' },
      { value: '07', label: 'Jul' },
      { value: '08', label: 'Aug' },
      { value: '09', label: 'Sep' },
      { value: '10', label: 'Oct' },
      { value: '11', label: 'Nov' },
      { value: '12', label: 'Dec' },
    ];

    let filteredMonths = months.map(month => ({
      key: month.value,
      value: month.label,
      label:month.label
    }));
    let newFilteredMonths = [{value: null, label : 'All'},...filteredMonths]
    this.setState({ monthList: newFilteredMonths });
  }

  getFilterList() {
    let years = [
      { value: 'month', label: 'Month-wise' },
      { value: 'name', label: 'Originator-wise' },
      {value: 'channel', label: 'Channel-wise'}
    ];
    let newFilterList = years.map(year => ({
      value: year.value,
      label: year.label
    }));
    this.setState({filterList: newFilterList})
  }

  getUsersS(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/superusers`,
      cacheKey: CacheKeys.Users(),
      callback: this.getUsersSCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getUsersSCallback = (response) => {
    let list = response.userList.map(user => ({
      value: user.userId,
      label:user.addressableName
    }));
    let newUserList = [{value:null, label: 'All'}, ...list]
    this.setState({errorList: response.errorList, userIdSList:newUserList});
  };

  getSalesChannels(context) {
    let cacheManager = new CacheManager({
      resource: `/api/reference/salesChannels`,
      cacheKey: CacheKeys.SalesChannel(),
      callback: this.getSalesChannelsCallback,
      ttlInSecs: 600
    });
    cacheManager.getObject2(context);
  }

  getSalesChannelsCallback = (response) => {
    let salesChannelList = response.salesChannelList.map(channel => ({
      key: channel.code,
      value: channel.name,
      label:channel.name
    }));
    let newSalesChannelList = [{ value: null, label: 'All' }, ...salesChannelList]
    this.setState({errorList: response.errorList, salesChannelList: newSalesChannelList });
  };
  
  onRefreshClick = () => {
    const { context } = this.props;
    CacheManager.removeObject(CacheKeys.SalesTargetList());
    CacheManager.removeObject(CacheKeys.Users()); 
    CacheManager.removeObject(CacheKeys.SalesChannel());

    this.setState({
      userIdList:[],
      salesTargetList: null,
      filteredSalesTargetList: null,
      yearList:[],
      monthList:[],
      errorList: null,
    });
    this.getFilteredMonthList();
    this.getSalesTargetList(context);
  };
}

export default withRouter(SalesChartPageSF);
